var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('PostContainer',{attrs:{"post":_vm.post,"section":_vm.section}}),(!_vm.$currentUser.loggedIn())?_c('CtaSignUp',{staticClass:"mb-8 px-6"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }